module.exports = __webpack_public_path__ + "img/aiBanner.a2489d6b.png";